import { useTranslation } from 'react-i18next'

import { useInitData } from '../../../../../hooks'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import {
  isRequestProfileHeaderFooterActionEmail,
  REQUEST_PROFILE_HEADER_FOOTER_ACTION,
  useRequestProfileHeaderFooterActions,
} from '../../../RequestProfileHeaderFooter'
import { REQUEST_PROFILE_ACTIONS_WIDGET_ACTION } from '../../RequestProfileActionsWidget.constants'
import {
  getRequestProfileActionsWidgetAddNewOptions,
  getRequestProfileActionsWidgetAttachedRequestsOptions,
} from '../../RequestProfileActionsWidget.utils'
import { useRequestProfileActionsWidgetCreateEmailAction } from '../useRequestProfileActionsWidgetCreateEmailAction'
import { useRequestProfileArchiveActions } from '../useRequestProfileArchiveActions'
import { useRequestProfileAttachedRequestsActions } from '../useRequestProfileAttachedRequestsActions'
import { useRequestProfileMarkAsUnread } from '../useRequestProfileMarkAsUnread'
import { useRequestProfileToggleVisibleToDwellers } from '../useRequestProfileToggleVisibleToDwellers'

export function useRequestProfileActionsWidgetHandlers({ onClickBack }) {
  const { t } = useTranslation()

  const { relatedRequestsCount, requestData } = useRequestProfileContext()

  const { sections } = useInitData()

  const requestId = requestData?.id

  const { actionHandlers: footerActionHandlers, getUploadFileInputProps } =
    useRequestProfileHeaderFooterActions()

  const { handleClickCreateEmail } =
    useRequestProfileActionsWidgetCreateEmailAction()

  const { handleClickToggleVisibleToDwellers } =
    useRequestProfileToggleVisibleToDwellers()

  const { handleClickMarkAsUnread } = useRequestProfileMarkAsUnread({
    requestId,
  })

  const { handleClickArchive, handleClickRestore } =
    useRequestProfileArchiveActions()

  const { handleSelectAttachedRequestsOption } =
    useRequestProfileAttachedRequestsActions({
      requestId,
      onClickCreate:
        footerActionHandlers[
          REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest
        ],
    })

  function handleSelectAddNewOption({ value }) {
    if (isRequestProfileHeaderFooterActionEmail(value)) {
      handleClickCreateEmail()
    } else {
      footerActionHandlers[value]?.()
    }
  }

  function handleClickAction({ value }) {
    switch (value) {
      case REQUEST_PROFILE_ACTIONS_WIDGET_ACTION.archive:
        handleClickArchive()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ACTION.back:
        onClickBack?.()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ACTION.markAsUnread:
        handleClickMarkAsUnread()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ACTION.restore:
        handleClickRestore()
        break
      case REQUEST_PROFILE_ACTIONS_WIDGET_ACTION.toggleVisibleToDwellers:
        handleClickToggleVisibleToDwellers()
        break
      default:
        break
    }
  }

  const addNewOptions = getRequestProfileActionsWidgetAddNewOptions({
    requestData,
    sections,
    t,
  })

  const attachedRequestsOptions =
    getRequestProfileActionsWidgetAttachedRequestsOptions({
      relatedRequestsCount,
      requestData,
      t,
    })

  return {
    addNewOptions,
    attachedRequestsOptions,
    getUploadFileInputProps,
    handleClickAction,
    handleSelectAddNewOption,
    handleSelectAttachedRequestsOption,
  }
}
